import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import getSportEventsByDateThunk from '../store/matches/actions/getSportEventsByDate';
import getLiveMatchScoreByIdThunk from '../store/matches/actions/getLiveMatchScoreById';
import getSportEventsByCompetitionIdMonthThunk from '../store/matches/actions/getSportEventsByCompetitionIdMonth';
import getSportEventsBySportMonthThunk from '../store/matches/actions/getSportEventsBySportTypeMonth';
import {Sport} from '../utils/types';
import getSportEventsByGroupIdThunk from '../store/matches/actions/getSportEventsByGroupId';

/**
 * Return type of the useMatchesActions hook
 */
export type UseMatchesActionsHook = {
  getMatchesByDate: typeof getSportEventsByDateThunk,
  getMatchesByCompetitionIdAndMonth: typeof getSportEventsByCompetitionIdMonthThunk,
  getMatchesBySportAndMonth: typeof getSportEventsBySportMonthThunk,
  getLiveMatchScoreById: typeof getLiveMatchScoreByIdThunk,
  getMatchesByGroupId: typeof getSportEventsByGroupIdThunk,
}

/**
 * Wraps up the action creators related to the 'matches' state.
 */
const useMatchesActions = (): UseMatchesActionsHook => {
  const dispatch = useDispatch();

  const getMatchesByDate = useCallback((date: string) => {
    return dispatch(getSportEventsByDateThunk(date));
  }, [dispatch]);

  const getMatchesByCompetitionIdAndMonth = useCallback((competitionId: string, month: string) => {
    return dispatch(getSportEventsByCompetitionIdMonthThunk(competitionId, month));
  }, [dispatch]);

  const getMatchesBySportAndMonth = useCallback((sport: Sport, month: string) => {
    return dispatch(getSportEventsBySportMonthThunk(sport, month));
  }, [dispatch]);

  const getMatchesByGroupId = useCallback((groupId: string) => {
    return dispatch(getSportEventsByGroupIdThunk(groupId));
  }, [dispatch]);

  const getLiveMatchScoreById = useCallback((id: string, date: string) => {
    return dispatch(getLiveMatchScoreByIdThunk(id, date));
  }, [dispatch]);



  return ({getMatchesByDate, getMatchesByCompetitionIdAndMonth, getMatchesBySportAndMonth, getLiveMatchScoreById, getMatchesByGroupId});
};


export default useMatchesActions;
